import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  // Si el usuario está autenticado, redirigir a la zona privada
  if (isAuthenticated) {
    return <Navigate to="/calculator" replace />;
  }

  return children;
};

export default PublicRoute;
